import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import { ggzoEmblEchelonToText } from '../../../../../../common/utils/ggzoEmblEchelonToText';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { FormSubHeader } from '../../../../elements/forms/formSection/FormSection';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export function GgzoEmbl1DiagnosticReportSummary(props: ICustomControlDiagnosticReportReadProps) {
    if (!props.diagnosticReport.customControlData) {
        return null;
    }

    return (
        <>
            {(props.diagnosticReport.customControlData.autoEchelonTypePrimary ||
                props.diagnosticReport.customControlData.psyEchelonTypePrimary) && (
                <>
                    <FormSubHeader>Advies</FormSubHeader>

                    <HorizontalFormGroupRead>
                        <FormLabel>Echelon</FormLabel>
                        <InputContainer>
                            {props.diagnosticReport.customControlData.psyEchelonTypePrimary && (
                                <FormParagraph>
                                    {ggzoEmblEchelonToText(
                                        props.diagnosticReport.customControlData.psyEchelonTypePrimary
                                    )}
                                </FormParagraph>
                            )}
                            {props.diagnosticReport.customControlData.autoEchelonTypePrimary && (
                                <>
                                    Automatisch berekende waarde:{' '}
                                    {ggzoEmblEchelonToText(
                                        props.diagnosticReport.customControlData.autoEchelonTypePrimary
                                    )}
                                </>
                            )}
                        </InputContainer>
                    </HorizontalFormGroupRead>
                </>
            )}
        </>
    );
}
